import { useAppStore } from '@/store/app-store'
import Container from '@cloudscape-design/components/container'
import Header from '@cloudscape-design/components/header'
import {
  colorBackgroundContainerContent,
  colorBorderDividerDefault,
  colorTextAccent,
  colorTextBodySecondary,
} from '@cloudscape-design/design-tokens'

export function ArchitectureDiagram() {
  const executionMode = useAppStore((s) => s.executionMode)
  const isCloud = executionMode === 'cloud'

  const boxStyle: React.CSSProperties = {
    border: `1px solid ${colorBorderDividerDefault}`,
    borderRadius: 6,
    padding: '6px 12px',
    color: colorTextAccent,
    fontSize: 12,
    fontWeight: 600,
    textAlign: 'center',
    backgroundColor: colorBackgroundContainerContent,
    whiteSpace: 'nowrap',
  }
  const arrow = <span style={{ color: colorTextAccent, fontSize: 16, fontWeight: 700 }}>{'\u2192'}</span>

  return (
    <Container header={<Header variant="h3">Architecture</Header>}>
      <div style={{ textAlign: 'center' as const, padding: '14px 18px' }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: 8, flexWrap: 'wrap', justifyContent: 'center' }}>
          <div style={boxStyle}>Your Browser</div>
          {isCloud ? (
            <>
              {arrow}
              <div style={boxStyle}>CloudFront</div>
              {arrow}
              <div style={boxStyle}>API Gateway</div>
              {arrow}
              <div style={boxStyle}>Lambda</div>
              {arrow}
            </>
          ) : (
            <>
              {arrow}
            </>
          )}
          <div style={{ display: 'flex', flexDirection: 'column', gap: 4 }}>
            <div style={boxStyle}>Bedrock</div>
            <div style={boxStyle}>Anthropic</div>
            <div style={boxStyle}>Grok / xAI</div>
          </div>
        </div>
        <div style={{ marginTop: 10, color: colorTextBodySecondary, fontSize: 11 }}>
          {isCloud
            ? 'Probes route through CloudFront → API Gateway → Lambda. TTFT includes network hops.'
            : 'Probes run directly from your browser to the provider APIs. No backend involved.'}
        </div>
      </div>
    </Container>
  )
}
